(() => {
  const bar = document.getElementById('vq-sticky-atc');
  if (!bar) return;

  const priceEl      = bar.querySelector('.vq-sticky-atc__price');
  const variantLabel = bar.querySelector('.vq-sticky-atc__variant');
  const imgEl        = bar.querySelector('.vq-sticky-atc__img');
  const cartBtn      = bar.querySelector('.vq-sticky-atc__btn');

  // Set-Betrieb: die Cross-Selling-Karte hat den Kauf uebernommen, der
  // echte Warenkorb-Button ist ausgeblendet. Dann haengt die Leiste am
  // Set-Button und zeigt dessen Summe statt des Variantenpreises.
  const setCard = bar.dataset.setMode === 'true'
    ? document.querySelector('vq-cross-sell')
    : null;
  const setTotalEl = setCard?.querySelector('[data-xsell-total]');
  const setLabelEl = bar.querySelector('[data-sticky-set-label]');

  // Shopify gibt Preise in Cent zurück (z.B. 15999 = 159,99 €)
  const toPrice = (cents) => {
    const format = window.Shopify?.money_format || '{{amount}} €';
    const value = (cents / 100).toFixed(2).replace('.', ',');
    return format
      .replace('{{amount_with_comma_separator}}', value)
      .replace('{{amount}}', value);
  };

  let scrollObserver, debounceTimer, footerInView = false;

  const showBar = (show) => {
    bar.classList.toggle('vq-sticky-atc--visible', show);
    bar.setAttribute('aria-hidden', String(!show));
  };

  // Dawn-Theme: ATC-Button befindet sich innerhalb des product-form Web Components
  const findRealBtn = () =>
    setCard
      ? setCard.querySelector('[data-xsell-submit]')
      : document.querySelector('product-form button[name="add"]');

  // Summe und Teilezahl kommen aus der Karte selbst - die rechnet bei
  // jeder Auswahl und jedem Variantenwechsel ohnehin neu.
  const syncSet = () => {
    if (!setCard) return;

    if (priceEl && setTotalEl) priceEl.textContent = setTotalEl.textContent.trim();

    // Das Hauptprodukt wandert immer mit, zaehlt also immer mit.
    const parts = setCard.querySelectorAll('[data-xsell-toggle]:checked').length + 1;
    if (setLabelEl) {
      setLabelEl.textContent = parts > 1
        ? `${bar.dataset.setLabel} (${parts} Teile)`
        : bar.dataset.singleLabel;
    }
  };

  const updateBar = (variant) => {
    if (!variant) return;

    if (priceEl) priceEl.textContent = toPrice(variant.price);

    if (variantLabel) {
      if (variant.title && variant.title !== 'Default Title') {
        variantLabel.textContent = variant.title;
        variantLabel.style.display = '';
      } else {
        variantLabel.style.display = 'none';
      }
    }

    if (variant.featured_image?.src && imgEl) {
      // srcset zuerst entfernen, sonst ignoriert der Browser das neue src
      imgEl.removeAttribute('srcset');
      imgEl.src = variant.featured_image.src;
    }
  };

  // Dawn rendert die aktuell gewählte Variante als JSON in einem script-Tag
  const getInitialVariant = () => {
    try {
      return JSON.parse(
        document.querySelector('script[data-selected-variant]')?.textContent
      );
    } catch (_) { return null; }
  };

  const updateButton = () => {
    // Dawn setzt das native disabled-Attribut direkt am Button
    cartBtn.disabled = findRealBtn()?.disabled ?? false;
  };

  const watchScroll = () => {
    scrollObserver?.disconnect();
    const realBtn = findRealBtn();
    if (!realBtn) return;

    // Sticky-ATC einblenden sobald der echte Button nach oben rausgescrollt ist
    scrollObserver = new IntersectionObserver(([entry]) => {
      if (footerInView) return;
      showBar(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    }, { threshold: 0 });

    scrollObserver.observe(realBtn);
  };

  const variantChanged = (variant) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      watchScroll();
      if (setCard) {
        syncSet();
      } else if (variant) {
        updateBar(variant);
      }
      updateButton();
    }, 60);
  };

  // Initialisierung
  watchScroll();
  updateButton();
  if (setCard) {
    syncSet();
    // Statt jeden Ausloeser einzeln abzufangen: sobald die Karte ihre
    // Summe neu schreibt, zieht die Leiste nach.
    if (setTotalEl) {
      new MutationObserver(syncSet).observe(setTotalEl, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    }
    setCard.addEventListener('change', () => requestAnimationFrame(syncSet));
  } else {
    updateBar(getInitialVariant());
  }

  // Beim Laden prüfen ob schon nach unten gescrollt wurde
  requestAnimationFrame(() => {
    const realBtn = findRealBtn();
    if (realBtn && !footerInView) showBar(realBtn.getBoundingClientRect().top < 0);
  });

  // Leiste verstecken wenn Footer sichtbar wird
  const footer = document.querySelector('footer.footer');
  if (footer) {
    new IntersectionObserver(([entry]) => {
      footerInView = entry.isIntersecting;
      if (footerInView) {
        showBar(false);
      } else {
        const realBtn = findRealBtn();
        if (realBtn) showBar(realBtn.getBoundingClientRect().top < 0);
      }
    }, { threshold: 0 }).observe(footer);
  }

  // Dawn's variant-selects feuert dieses Event nach jedem Variantenwechsel
  document.addEventListener('variant:change', (e) => {
    variantChanged(e.detail?.variant ?? null);
  });

  // Klick auf Sticky-Button löst den echten ATC-Button aus
  cartBtn.addEventListener('click', () => findRealBtn()?.click());
})();
